import { Contract, Opportunity, Order } from '@epilot/customer-portal-client'

import { formatAddress } from 'utils/CommonUtils'
import { Address } from 'utils/OrderUtils'

export const getDeliveryAddress = (data: Order | Opportunity | Contract) => {
  const deliveryAddress = data?.delivery_address as Address[]

  if (!deliveryAddress?.length) {
    return null
  }

  return formatAddress(deliveryAddress[0])
}
